module.exports = __webpack_public_path__ + "static/media/marknellemann.4b6ab390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/marknellemann.jpg
// module id = 614
// module chunks = 0